import React, { useState, useCallback, useEffect } from "react";
import { Box, TextField, Typography, IconButton } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const IxcDesbloquearNode = React.memo(({ data, id }) => {
  const [idClienteVariable, setIdClienteVariable] = useState(
    data?.idClienteVariable || "ixc_cliente_id"
  );
  const storageItems = useNodeStorage();

  const updateNodeData = useCallback(() => {
    data.idClienteVariable = idClienteVariable;
  }, [idClienteVariable, data]);

  useEffect(() => {
    updateNodeData();
  }, [idClienteVariable, updateNodeData]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        width: 280,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        border: "2px solid #e65100",
      }}
    >
      <Handle
        type="target"
        position="left"
        id="ixcDesbloquear-in"
        style={{
          left: -8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#e65100",
          width: 12,
          height: 12,
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LockOpenIcon fontSize="small" sx={{ color: "#e65100" }} />
          <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "#e65100" }}>
            IXC: Desbloquear
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <TextField
        label="Variável com ID do Cliente"
        variant="outlined"
        size="small"
        value={idClienteVariable}
        onChange={(e) => setIdClienteVariable(e.target.value)}
        fullWidth
        placeholder="ixc_cliente_id"
        helperText="ID do cliente para buscar contrato e desbloquear"
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Typography variant="caption" color="textSecondary">
          Saída: ixc_desbloqueio_sucesso, ixc_desbloqueio_mensagem,
          ixc_contrato_id
        </Typography>
      </Box>

      <Handle
        type="source"
        position="right"
        id="success"
        style={{
          right: -8,
          top: "30%",
          background: "#4caf50",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "27%", color: "#4caf50", fontSize: "0.65rem" }}
      >
        Desbloqueado
      </Typography>

      <Handle
        type="source"
        position="right"
        id="nao_bloqueado"
        style={{
          right: -8,
          top: "50%",
          background: "#2196f3",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "47%", color: "#2196f3", fontSize: "0.65rem" }}
      >
        Não bloqueado
      </Typography>

      <Handle
        type="source"
        position="right"
        id="error"
        style={{
          right: -8,
          top: "70%",
          background: "#f44336",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "67%", color: "#f44336", fontSize: "0.65rem" }}
      >
        Erro
      </Typography>
    </Box>
  );
});

export default IxcDesbloquearNode;
